export default __webpack_public_path__ + "static/icon-cb0d15601b6a653298d9754a578ae635.png";